// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UVF-","input":"styles_input__2T-S_"};